'use client';

import * as React from 'react';
import { Player } from '@alien-platform/bo-core';
import { CircularProgress } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { PlayerStatsTable } from './player-stats-table';

export function PlayerStatsTab({ playerData }: { playerData: Player | undefined }): React.JSX.Element {
  return (
    <Stack direction="column">
      {!playerData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <PlayerStatsTable playerData={playerData} />
        </Stack>
      )}
    </Stack>
  );
}
